import { Flex } from '@billy/design-system'
import React from 'react'

import { reactClass } from '../../utils'

export type PopOverFooterProps = {
  centered?: boolean
  children?: React.ReactNode
}

export const PopOverFooter = ({ centered, children }: PopOverFooterProps) => (
  <Flex className={reactClass('pop-over-footer')} justifyContent={centered ? 'center' : 'space-between'}>
    {children}
  </Flex>
)
